export const formatVersionName = (version: string) => {
  const versionNumber = /\d+/.exec(version)?.[0].replace(/^0+/, '');

  if (!versionNumber) {
    return 'V';
  }

  const displayVersionNumber = `V${versionNumber}`;

  const versionName = version.replace(/^Version\s*\d+\s*/i, '');

  if (!versionName) {
    return displayVersionNumber;
  }

  return `${displayVersionNumber} - ${versionName}`;
};

type OptionItem = {
  value: string;
  label: string;
  isDisabled: boolean;
};

export const unifyCustomColumnOptionList = (
  optionList: OptionItem[] | string[] | number[],
) => {
  return optionList.map((option) => {
    if (typeof option === 'string' || typeof option === 'number') {
      return { label: option, value: option, isDisabled: false };
    }
    return option;
  });
};
